// Public build configuration; the build runner also uses it for HTML/SEO.
export const APP_NAME = (process.env.REACT_APP_APP_NAME || '').trim() || 'PhotoChap';
